"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallPageMargin = exports.NavBarPaddingVerticalSmall = exports.NavBarPaddingVerticalMedium = exports.NavBarPaddingVerticalLarge = exports.NavBarPaddingHorizontalSmall = exports.NavBarPaddingHorizontalMedium = exports.NavBarPaddingHorizontalLarge = exports.ModalActionButtonsInline = exports.ButtonToggleGroupPaddingHorizontalSmall = exports.ButtonToggleGroupPaddingHorizontalMedium = exports.ButtonToggleGroupPaddingHorizontalLarge = exports.ButtonGroupPaddingVerticalSmall = exports.ButtonGroupPaddingVerticalMedium = exports.ButtonGroupPaddingVerticalLarge = exports.ButtonGroupPaddingHorizontalSmall = exports.ButtonGroupPaddingHorizontalMedium = exports.ButtonGroupPaddingHorizontalLarge = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonGroupPaddingHorizontalLarge = 32;
exports.ButtonGroupPaddingHorizontalLarge = ButtonGroupPaddingHorizontalLarge;
var ButtonGroupPaddingHorizontalMedium = 24;
exports.ButtonGroupPaddingHorizontalMedium = ButtonGroupPaddingHorizontalMedium;
var ButtonGroupPaddingHorizontalSmall = 16;
exports.ButtonGroupPaddingHorizontalSmall = ButtonGroupPaddingHorizontalSmall;
var ButtonGroupPaddingVerticalLarge = 32;
exports.ButtonGroupPaddingVerticalLarge = ButtonGroupPaddingVerticalLarge;
var ButtonGroupPaddingVerticalMedium = 24;
exports.ButtonGroupPaddingVerticalMedium = ButtonGroupPaddingVerticalMedium;
var ButtonGroupPaddingVerticalSmall = 16;
exports.ButtonGroupPaddingVerticalSmall = ButtonGroupPaddingVerticalSmall;
var ButtonToggleGroupPaddingHorizontalLarge = 16;
exports.ButtonToggleGroupPaddingHorizontalLarge = ButtonToggleGroupPaddingHorizontalLarge;
var ButtonToggleGroupPaddingHorizontalMedium = 12;
exports.ButtonToggleGroupPaddingHorizontalMedium = ButtonToggleGroupPaddingHorizontalMedium;
var ButtonToggleGroupPaddingHorizontalSmall = 12;
exports.ButtonToggleGroupPaddingHorizontalSmall = ButtonToggleGroupPaddingHorizontalSmall;
var ModalActionButtonsInline = 8;
exports.ModalActionButtonsInline = ModalActionButtonsInline;
var NavBarPaddingHorizontalLarge = 32;
exports.NavBarPaddingHorizontalLarge = NavBarPaddingHorizontalLarge;
var NavBarPaddingHorizontalMedium = 24;
exports.NavBarPaddingHorizontalMedium = NavBarPaddingHorizontalMedium;
var NavBarPaddingHorizontalSmall = 16;
exports.NavBarPaddingHorizontalSmall = NavBarPaddingHorizontalSmall;
var NavBarPaddingVerticalLarge = 32;
exports.NavBarPaddingVerticalLarge = NavBarPaddingVerticalLarge;
var NavBarPaddingVerticalMedium = 24;
exports.NavBarPaddingVerticalMedium = NavBarPaddingVerticalMedium;
var NavBarPaddingVerticalSmall = 16;
exports.NavBarPaddingVerticalSmall = NavBarPaddingVerticalSmall;
var SmallPageMargin = 16;
exports.SmallPageMargin = SmallPageMargin;